<div class="flex justify-center items-center gap-4">
  <div [ngClass]="{ 'text-danger': isExpired() }">Time Left: {{ isExpired() ? "Expired" : displayTime() }}</div>
  @if (isExpiredOrNearExpiration()) {
    <app-pan-button (click)="renewReview()" color="warning"> Extend review deadline </app-pan-button>
  }
</div>
